<app-breadcrumbs></app-breadcrumbs>

<h1>
  {{ category?.name }}
</h1>

<p>{{ category?.description }}</p>

<div class="row">
  <div class="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-8 col-md-offset-2">
    <app-gallery-searchbar [fieldSize]="'medium'"></app-gallery-searchbar>
  </div>
</div>

<div class="row middle-xs" *ngIf="parentCollection === 'plants'">
  <div class="col-xs-12 col-sm-2">
    <p class="h4">
      <nb-icon icon="funnel-outline"></nb-icon>
      Filters
    </p>
  </div>
  <div class="col-xs-6 col-sm-3">
    <nb-icon icon="sun-outline"></nb-icon>
    <nb-select
      #sunSelector
      (click)="layoutService.setScrollStrategyOnSelectComponent(sunSelector, 'noop')"
      (selectedChange)="updateFilters()"
      [(ngModel)]="filterSunExposure"
      multiple
      placeholder="Sun Exposure"
    >
      <nb-option value="full">Full</nb-option>
      <nb-option value="part">Part</nb-option>
      <nb-option value="shade">Shade</nb-option>
    </nb-select>
  </div>
  <div class="col-xs-6 col-sm-3">
    <nb-toggle (change)="updateFilters()" status="basic" [(ngModel)]="filterNatives">
      Native Plants
    </nb-toggle>
  </div>
</div>

<app-doc-scroller [recordSize]="isHandset ? 440 : 375" (updateQueries)="search($event)">
  <ng-template let-doc="doc">
    <div class="row">
      <div
        [ngClass]="{ 'col-xs-12': isHandset, 'col-xs-3': !isHandset }"
        *ngFor="let d of doc; trackBy: identify"
      >
        <app-gallery-record-card [record]="d"></app-gallery-record-card>
      </div>
    </div>
  </ng-template>
</app-doc-scroller>
